// extracted by mini-css-extract-plugin
export default {"h1":"CaseGallary_h1__tOm6j"};